
import { useEffect, useState } from "react"
import { Box, Paper, Typography, Button, CircularProgress } from "@mui/material"
import { useSnackbar } from 'notistack';

import sendRequest from '../services/sendRequest'
import ProgrammeRuleEntry from './programmeRuleEntry';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

const ProgrammeRule = ({ options, setData, rowToEdit, data, isNew }) => {

  const field = 'programme_rules'

  const [loading, setLoading] = useState(true)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  useEffect(() => {
    let fetched = false;
    async function getRules() {
      if (fetched || isNew) return
      const rules = await sendRequest({ requestType: "get", endpoint: `programmerules/?programme=${rowToEdit.custom_id}` })
      if (rules.code) {
        handleAllTypesOfMessages('Failed to load Data!', 'error')
      } else {
        setData(oldData => ({ ...oldData, [field]: rules.data }))
      }
    }
    
    getRules().finally(() => setLoading(false))
    return () => fetched = true
  }, [])

  const addRelatedField = () => {
    if (!(field in data)) {
      setData(oldData => ({ ...oldData, [field]: [{}] }))
    } else {
      setData(oldData => ({ ...oldData, [field]: [...oldData[field] || [], {}] }))
    }
  }

  const remove = (index) => setData(oldData => {
    const relatedField = [...oldData['programme_rules']]
    relatedField.splice(index, 1)
    return { ...oldData, ['programme_rules']: relatedField }
  })

  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };

  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
      aria-label="close"
      color="inherit"
      onClick={() => closeSnackbar(key)}
      >
      <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <Box
        component={Paper}
        noValidate
        mt={3}
        py={3}
        px={2}
      >
        <Typography
          variant='h6'
          pb={2}
        >
          Rules...
        </Typography>
          {
            loading
            ? 
              <CircularProgress />
            :
              <>
                {
                  data?.programme_rules && data.programme_rules.filter(rule => rule !== "series").map((rule, index) => 
                    <ProgrammeRuleEntry
                      key={rule.id}
                      index={index}
                      options={options[field]}
                      setData={setData}
                      rowToEdit={rule}
                      remove={() => remove(index)}
                    />
                )}
                <Button
                  onClick={addRelatedField}
                >
                  Add new Rule +
                </Button>
              </>
            }
      </Box>
    </div>
  )
}

export default ProgrammeRule
